import React, { useState, useEffect } from "react";
import { Snackbar } from "@mui/material";

const ConfirmSnackbar = ({ snackbarInfo }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (snackbarInfo) {
      setOpen(true);
    }
  }, [snackbarInfo]);

  const handleCloseSnackbar = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: snackbarInfo?.vertical || "top",
        horizontal: snackbarInfo?.horizontal || "center",
      }}
      open={open}
      onClose={handleCloseSnackbar}
      message={snackbarInfo?.message}
      autoHideDuration={snackbarInfo?.autoHideDuration ?? 3000}
      TransitionComponent={snackbarInfo?.Transition}
    />
  );
};

export default ConfirmSnackbar;
